// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"c2695128","115":"6510f652","374":"41cc414f","471":"189d8251","554":"b0dc50b0","708":"c35c4e98","942":"246eeb7a","946":"98e20f61"}[chunkId] + ".chunk.css";
};